export const footer: string = "relative z-10 w-full border-t border-white/10 bg-slate-950 pb-6 ";
export const footerContainer: string = "w-full flex pt-6 pb-3 gap-7 lg:gap-9 place-content-center ";
export const footerIcon: string = "text-slate-400 hover:text-sky-400 transition text-2xl md:text-3xl cursor-pointer ";
